<template>
  <div>
    <md-dialog :md-active.sync="application_update_status_dialog.show">
      <md-dialog-title>
        Update Application Status
        <span class="md-caption"
          >(ID:
          {{
            application_update_status_dialog.application &&
            application_update_status_dialog.application.id
          }})</span
        >
        <span style="margin-left: 6px;" v-if="tooltipText" >
          <md-tooltip style="text-align: left;"
            :md-direction="tooltipDirection"
            v-html="tooltipText"
          >
          </md-tooltip>
          <md-icon>info</md-icon>
        </span>
      </md-dialog-title>

      <div class="md-layout">
        <!-- Stage & Status -->
        <edit-loan-status
          class="md-layout-item md-size-100"
          v-model="application_update_status_dialog"
          :permissions="permissions"
          show-archive
        />
      </div>
      <md-dialog-actions>
        <md-button class="md-primary md-simple" @click="onCloseUpdateStatusDialog">
          Cancel
        </md-button>
        <loading-icon-text-button @click="checkStatus" icon="save" :loading="saving">
          Save
        </loading-icon-text-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog class="md-layout" :md-active.sync="declinedDialog">
      <div class = "wrapper">
        <div>
          <h4>Lenders Available</h4>
        </div>
        <md-table :value="products" md-card md-sort="advise_order">
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="" md-sort-by="advise_order">{{ item.advise_order }}</md-table-cell>
            <md-table-cell md-label="Lenders">
              <img :src="'/images/lenders/' + item.lender_id + '.png'" :alt="item.lender_name" style="width: 30%"/>
            </md-table-cell>
            <md-table-cell md-label="Approval Rate">{{ item.approval_rate }}</md-table-cell>
            <md-table-cell md-label="Product">{{ item.product_name }}</md-table-cell>
            <md-table-cell md-label="Have you submitted?">
              <md-checkbox v-model="item.is_submitted" class="is_submitted_checkbox"></md-checkbox>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div>
          <h4>Why was the lender advice incorrect?</h4>
        </div>
        <div md-card class="declined_text">
          <v-textarea
            label="Type here your reason(s)"
            v-model="typedReasons"
            outlined
          >
          </v-textarea>
        </div>
        <md-dialog-actions>
          <md-button class="md-primary md-simple" @click="onCloseDeclinedDialog">
            Cancel
          </md-button>
          <loading-icon-text-button @click="confirmDeclined" icon="save" :loading="saving">
            Confirm
          </loading-icon-text-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="confirm_dialog.show"
      :md-title="confirm_dialog.title"
      :md-content="confirm_dialog.content"
      :md-confirm-text="confirm_dialog.confirm_text"
      :md-cancel-text="confirm_dialog.cancel_text"
      @md-confirm="confirm_dialog.action"
    />

    <md-dialog-confirm
      :md-active.sync="redirect_dialog.show"
      :md-title="redirect_dialog.title"
      :md-content="redirect_dialog.content"
      :md-confirm-text="redirect_dialog.redirect_text"
      :md-cancel-text="redirect_dialog.close_text"
      @md-confirm="redirect_dialog.action"
    />

    <md-dialog-alert
      :md-active.sync="error_dialog.show"
      :md-title="error_dialog.title"
      :md-content="error_dialog.content"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { GroupCard } from "@/components";
import ValidatedInputs from "@/components/ValidatedInput";
import ButtonGroupInput from "@/components/ValidatedInput/ButtonGroupInput.vue";
import ApplicationList from "@/components/ApplicationList";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";
import EditLoanStatus from "@/components/Editors/EditLoanStatus";
import filters from "@/components/utils/filters";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";

export default {
  components: {
    GroupCard,
    ...ValidatedInputs,
    ButtonGroupInput,
    ApplicationList,
    LoadingIconTextButton,
    EditLoanStatus,
    WaitingDialog
  },
  props: {
    tooltipDirection: {
      type: String,
      default: 'top'
    },
  },
  data() {
    return {
      saving: false,
      declinedDialog: false,
      selectedReasons: [],
      typedReasons: "",
      totalReasons: "",
      confirm_dialog: {
        show: false,
        content: "",
        title: "",
        confirm_text: "Confirm",
        cancel_text: "Cancel",
        action: () => {}
      },
      redirect_dialog: {
        show: false,
        content: "",
        title: "",
        redirect_text: "",
        close_text: "",
        action: () => {}
      },
      error_dialog: {
        show: false,
        title: "",
        content: ""
      },
      tooltipText: '<li>If unable to complete application set to follow up in status and match in Dialler</li>' +
                   '<li>If unable to get documents while on the phone with the client the status should be changed to Docs/Awaiting Docs as shown and follow up at end of shift and beginning of shift</li>',
    };
  },
  watch: {
    "application_update_status_dialog": {
      handler: function(newValue) {
        if (newValue.status !== "Declined") {
          this.declinedDialog = false;
        };
      },
      deep: true,
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "userHasPermission",
      "userHasRole",
      "application_update_status_dialog",
      "application",
      "ml_assessment",
      "agent_has_visibility_subscription"
    ]),
    isAllowedDealIncomes() {
      // Show to all user but agents with subscription ON
      return !this.agent_has_visibility_subscription;
    },
    permissions() {
      return this.application_update_status_dialog &&
        this.application_update_status_dialog.application
        ? this.application_update_status_dialog.application.permissions
        : null;
    },
    products() {
      if (this.ml_assessment && this.ml_assessment.top_recommendations && this.ml_assessment.top_recommendations.length > 0) {
        this.ml_assessment.top_recommendations.sort((a,b) => a.advise_order - b.advise_order);
        if (this.ml_assessment.top_recommendations.length > 3) {
          return this.ml_assessment.top_recommendations.slice(0,3)
        }
        return this.ml_assessment.top_recommendations;
      } else {
        return [];
      }
    }
  },
  methods: {
    async sendDeclineNotification (id) {
      await axios.post(`/api/v1/application/send-client-declined-notification`, {
        application_id: id
      }).catch((error) => {
        this.showDialogPopup("Failed to send to notification", error.response.data ?? 'Error');
      })
    },
    onCloseUpdateStatusDialog() {
      this.$store.commit("set_application_update_status_dialog", null);
    },
    onCloseDeclinedDialog() {
      this.declinedDialog = false;
      this.$store.commit("set_application_update_status_dialog", null);
    },
    showConfirmDialog (content, action, buttonOptions = {}, show = true) {
      this.confirm_dialog.content = content
      this.confirm_dialog.confirm_text = buttonOptions.confirm ?? "Confirm"
      this.confirm_dialog.cancel_text =  buttonOptions.cancel ?? "Cancel"
      this.confirm_dialog.action = action
      this.confirm_dialog.show = show
    },
    showRedirectDialog (content, action, show = true) {
      this.redirect_dialog.content = content
      this.redirect_dialog.title = "Error"
      this.redirect_dialog.redirect_text = "Go To Deal Income"
      this.redirect_dialog.close_text =  "Close"
      this.redirect_dialog.action = action
      this.redirect_dialog.show = show
    },
    async saveUpdateStatus() {
      if (this.saving == true) {
        return;
      }
      this.saving = true;
      try {
        const application_id =  this.application_update_status_dialog.application.id
        let is_open_application = application_id == this.$store.getters.application_status.id;

        await axios.post(
          `/api/v1/application/${application_id}/status`,
          {
            stage: this.application_update_status_dialog.stage,
            status: this.application_update_status_dialog.status,
            reason: this.application_update_status_dialog.reason,
            comment: this.application_update_status_dialog.comment,
            send_email: this.application_update_status_dialog.send_email || false,
            email_body: this.application_update_status_dialog.email_body,
            broker: this.application_update_status_dialog.broker ?? null,
          }
        );

        // update submission status when status is "Submitted", "Approved - Conditional" and "Approved"
        // use active submission and when active id is null, use lastest previous submission
        let status = this.application_update_status_dialog.status;
        if (status === "Submitted" || status === "Approved - Conditional" || status === "Approved") {
          let submission_payload = {};
          if (this.application.loan.submission.active.id) {
            submission_payload = this.getSubmissionPayload(this.application.loan.submission.active);
          } else if (this.application.loan.submission.previous.length >= 1) {
            submission_payload = this.getSubmissionPayload(this.application.loan.submission.previous[0]);
          }
          if (Object.keys(submission_payload).length !== 0) {
            await this.$store.dispatch("update_submission_data", {application_id: this.application.loan.id, submission: submission_payload});
          }
        }

        this.$store.commit("set_work_basket", null);
        if (is_open_application) {
          //remove application dirty state
          this.$store.commit("setApplicationStatus", {dirty: false})
          await this.$store.dispatch("reload_application");
        }

        if (status === "Declined") {
          const dialogContent = 'Do you wish to send a declined email notification to customer?'
          this.showConfirmDialog(dialogContent, () => this.sendDeclineNotification(application_id) , { confirm: 'Yes', cancel: 'No' })
        }

        this.onCloseUpdateStatusDialog();
        let auctionType = ["Auction", "MQL Auction", "Distribution"];
        if (auctionType.includes(status)) {
          this.showDialogPopup("Success", "Successfully created an auction");
        }

        if (status === "Live Transfer") {
          this.saving = false;
          this.showDialogPopup("Success", "Transfer to Broker successfully");
          await this.$store.dispatch('release_application_lock', application_id);
          this.$router.push(`/application/new/basket`);
        }

        if (status === "Live Auction") {
          await this.subscribeToPusher(application_id);
          this.showDialogPopup("Success", "Successfully created live auction");
          if (this.$router.currentRoute.name !== "Workbasket") {
            this.$router.push('./basket');
          }
        }
      } catch (error) {
        console.error(error);
        this.onCloseUpdateStatusDialog();
        this.showDialogPopup("Error", error.response.data ?? error);
      }
      this.declinedDialog = false;
      this.saving = false;
    },
    async subscribeToPusher(application_id) {
      const channelName = "live-auction-channel." + application_id;
      const { pusher, channel } = await this.$store.dispatch('subscribe_to_pusher_channel', channelName);
      if (channel === null) {
        return;
      }
      const vue = this;
      channel.bind('live-auction', function(data) {
          let message = data["message"];
          let applicationID = data["applicationId"];
          vue.notify({
            'message': message + " . Application ID: " + applicationID,
            'timeout': 300000,
            'verticalAlign': 'top',
            'horizontalAlign': 'center',
            'hardNotification': true
          })
          pusher.unsubscribe('live-auction-channel.' + application_id);
      });
    },
    async checkStatus() {
      //Check if status == Declined
      if (this.application_update_status_dialog.status == "Declined") {
        this.saving = true;

        try {
          await this.$store.dispatch("fetch_ml_assessment");
        } catch(error) {
          console.error(error);
        }

        if (this.ml_assessment && this.ml_assessment.top_recommendations && this.ml_assessment.top_recommendations.length > 0) {
          // add isSubmitted
          this.ml_assessment.top_recommendations.forEach(option => this.$set(option, 'is_submitted', false));
          this.saving = false;
          this.declinedDialog = true;
          this.application_update_status_dialog.show = false
        } else {
          this.saving = false;
          this.saveUpdateStatus();
        }
        return;
      }

      //Check if status == Auction
      if (this.application_update_status_dialog.status === "Auction") {
        const dialogContent = "This will create an auction for this application. You can only do it once."
        this.showConfirmDialog(dialogContent, this.saveUpdateStatus)
        return;
      }

      if (this.application_update_status_dialog.status === "MQL Auction") {
        if (!this.userHasRole("super-admin")) {
          this.showDialogPopup(
            "Error",
            "Only admin can create MQL Auction!"
          )
          return;
        }
      }

      // Check if status === Settled
      if (this.application_update_status_dialog.status === "Settled") {
        if (!this.userHasRole("super-admin") && !this.application.loan.settlement && isAllowedDealIncomes) {
          const application_id = this.application_update_status_dialog.application.id;
          const dialogContent = "Settlement date must be entered and Deal Income finalised to proceed to Settled status.";
          this.showRedirectDialog(dialogContent, () => this.redirectToDealIncomes(application_id));
          return;
        }
      }

      if (this.application_update_status_dialog.status === "Fail"
      && !this.userHasRole('super-admin')
      && !this.userHasRole('Compliance Officer')) {
        this.showDialogPopup(
          "Error",
          "Only Admin and Compliance Officer are able to save Reason for Fail status!"
        )
        return;
      }

      this.saveUpdateStatus();
    },
    redirectToDealIncomes(loan_application_id) {
      this.application_update_status_dialog.show = false;
      this.redirect_dialog.show = false;
      this.$router.push({ path: '/application/' + loan_application_id + '/deal_income' });
      this.$modal.show(WaitingDialog, {
              title: 'Processing...',
              message: 'Taking you to deal income page once the application is retrieved.',
      });
      setTimeout(() => {
      // Close Loading Screen
      if (this.$modal.submit) {
          this.$modal.submit();
        }
      }, 2000);
    },
    async releaseLock(loan_application_id) {
      await this.$store.dispatch('release_application_lock', loan_application_id)
      await this.getAppLocks();
    },
    async confirmDeclined() {
      if (this.typedReasons === "") {
        this.showDialogPopup(
          "Reason input cannot be empty",
          "Please enter some text"
        )
        return;
      }
      // get submitted lenders
      const submittedLenders = this.ml_assessment.top_recommendations.filter(option => option.is_submitted).map(option => option.lender_name);
      this.saving = true;
      let payload = {
        application_id: this.application_update_status_dialog.application.id,
        reasons: [this.typedReasons],
        submitted_lenders: submittedLenders,
      };
      //Sending Email to BA team
      try {
        await axios.post(`/api/v1/application/submit_to_BA`, payload);
      } catch (e) {
        console.log(e);
      } finally {
        this.typedReasons = "";
      }

      this.declinedDialog = false;
      this.saving = false;
      this.saveUpdateStatus();
    },
    showDialogPopup(title, message) {
      this.error_dialog.title = title;
      this.error_dialog.content = message;
      this.error_dialog.show = true;
    },
    getSubmissionPayload(submission) {
      let status = "";
      switch (this.application_update_status_dialog.status) {
        case 'Submitted':
          status = "Submitted";
          break;
        case 'Approved - Conditional':
          status = "Conditionally Approved";
          break;
        case 'Approved':
          status = "Approved";
          break;
      }
      return {
        id: submission.id,
        status: status,
        payment_frequency: submission.payment_frequency,
        naf: submission.naf,
        rate: submission.rate,
        term: submission.term,
        repayments: submission.repayments,
        document_origination_fee: submission.document_origination_fee,
        risk_fee: submission.risk_fee,
        establishment_fee: submission.establishment_fee,
        ppsr_fee: submission.ppsr_fee,
        response_message: submission.response_message,
      }
    },
  },
  filters: {
    ...filters,
  },
  created() {
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 40vw;
  height: auto;
  margin-bottom: 20px;
  padding: 30px;

  .md-table {
    height: 20vh;
  }

  .md-dialog-actions {
    align-self: end;
    padding-right: 30px;
  }

  .declined_text {
    align-self: start;
    width: 100%;
    margin-top: 20px;
  }
}

.is_submitted_checkbox {
  margin: 0;
}

</style>
